import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Validator,
  RequiredRule,
  CustomRule,
} from "devextreme-react/validator";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { useSearchParams } from "react-router-dom";
import DateBox from "devextreme-react/date-box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { api_path } from "../../shared.js";
import "../../modalActivity.css";

function AddActivityModal(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [getLoadGrid, setLoadGrid] = useState();
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  // ------------------- STATES -------------------
  const [activityName, setActivityName] = useState("");
  const [createBy, setCreateBy] = useState("");
  const [customer, setCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [sale, setSale] = useState(null);
  const [saleList, setSaleList] = useState([]);
  const [getStatus, setStatus] = useState(null);
  //const [statusList, setStatusList] = useState([]);
  const [activityDate, setActivityDate] = useState(null);

  const [remark, setRemark] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [reminderChecked, setReminderChecked] = useState(false);
  const [reminderDate, setReminderDate] = useState(null);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const dateTimeLabel = { "aria-label": "Date Time" };
  const token = process.env.REACT_APP_API_TOKEN;
  //const isDisabled = props.ROLE_ID != "1";
  const isDisabled = props.ROLE_ID != "1" && props.ROLE_ID != "2";
  // ------------------- EFFECTS -------------------
  useEffect(() => {
    if (props.ROLE_ID == "1" || props.ROLE_ID == "2") {
      // กำหนดหัวข้อ modal ตาม flag
      if (props.ACTIVITY_ID > 0) {
        setSubjectName(
          props.FLAG == "EDIT" ? "Edit Activity" : "Copy Activity"
        );
      } else {
        setSubjectName("New Activity");
      }
    } else {
      setSubjectName("Create Follow-up Task");
      setStatus({ value: 8, label: "Follow-up" });
      //setSelectStatus(8);
    }
    if (props.CUSTOMER_CODE) {
      setCustomer(props.CUSTOMER_CODE);
      setSale(getUserID);
    } else {
      // กรณีไม่มี props ให้ fetch ทั้งหมด
      fetchCustomer();
      fetchSale();
    }
    //fetchStatus();
    setCreateBy(getUserEMail.replace("@sinologistics.co.th", ""));
    // ถ้าเป็น edit ให้ fetch activity info
    if (props.ACTIVITY_ID && (props.FLAG == "EDIT" || props.FLAG == "COPY")) {
      fetchActivityData(props.ACTIVITY_ID, props.CUSTOMER_CODE);
    }
  }, [props.ACTIVITY_ID, props.FLAG, props.CUSTOMER_CODE]);
  const fetchActivityData = async (activityId, CRM_CUSCODE) => {
    try {
      const response = await axios.get(
        `${api_path}/customer/customer_activities.php`,
        {
          params: { SALES_ACTIVITY_ID: activityId, CRM_CUSCODE: CRM_CUSCODE },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data && response.data.length > 0) {
        const data = response.data[0];
        setActivityName(data.TOPIC || "");
        setRemark(data.DESCRIPTION || "");
        setStatus({
          value: data.ACTIVITY_ID,
          label: data.ACTIVITY_NAME,
        });
        setCustomer(
          data.CRM_CUSCODE
            ? {
                CRM_CUSCODE: data.CRM_CUSCODE,
                CUSTOMER_NAME: data.CUSTOMER_NAME,
              }
            : null
        );
        setSale(data.SALES_CODE);
        setActivityDate(data.ACTIVITY_DATE);
        if (data.REMINDER) {
          setReminderChecked(true);
          setReminderDate(data.REMINDER);
        }
      }
    } catch (error) {
      console.error("Error fetching activity data:", error);
    }
  };
  const statusList = [
    { value: "1", label: "Telesales" },
    { value: "2", label: "Sales Visit" },
    { value: "3", label: "Quotation" },
  ];
  const fetchCustomer = () => {
    axios
      .get(`${api_path}/customer/customers.php?flag=all&SALES_CODE=${getEmpCode}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setCustomerList(response.data))
      .catch((err) => console.log(err));
  };
  const fetchSale = async () => {
    try {
      const response = await axios.get(`${api_path}/GET_SALES.php`, {
        params: { role: getUserRole, user: getUserID },
      });
      setSaleList(response.data);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };
  // ------------------- HANDLERS -------------------
  const onValueDateChanged = React.useCallback((e) => {
    if (e.value) {
      const d = new Date(e.value);
      const pad = (n) => n.toString().padStart(2, "0");
      const formattedDateTime =
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

      setActivityDate(formattedDateTime);
    } else {
      setActivityDate(null);
    }
  }, []);
  const onValueReminderDateChanged = React.useCallback((e) => {
    if (e.value) {
      const d = new Date(e.value);
      const pad = (n) => n.toString().padStart(2, "0");
      const formattedDateTime =
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

      setReminderDate(formattedDateTime);
    } else {
      setReminderDate(null);
    }
  }, []);
  const handleStatusChange = (obj) => setStatus(obj);
  const handleCustomerChange = (obj) => setCustomer(obj);
  const handleSaleChange = (obj) => setSale(obj);

  const handleSubmit = (e) => {
    e.preventDefault();
    // ✅ เช็คตรงนี้อีกที
    if (reminderChecked && !reminderDate) {
      swal("Please enter a date for the reminder", "", "error");
      return;
    }
    var data = {
      SALES_ACTIVITY_ID: props.FLAG == "COPY" ? 0 : props.ACTIVITY_ID || 0,
      CRM_CUSCODE: customer?.CRM_CUSCODE || props.CUSTOMER_CODE,
      ACTIVITY_ID: getStatus?.value || "",
      SALES_CODE: getEmpCode,
      CRM_UID: getUserID,
      TOPIC: activityName,
      COMMENT: remark,
      ACTIVITY_DATE: activityDate,
      ACTIVITY_DATE_END: activityDate,
      SHARED_FLAG: 0,
      ATTACHMENT_NAME: remark,
      FILE_PATH: "",
      REMINDER: reminderChecked ? reminderDate : null, // ✅ ส่ง null ถ้าไม่ติ๊ก
      ACT_CREATEBY: getUserID,
      RECORD_FROM: "Web",
    };
    fetch(`${api_path}/customer/customer_activities.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status == "200") {
          swal("Done", "Save data successfully", "success").then(() => {
            if (props.PAGE == "GRID") {
              // 1. ปิด modal
              props.onClose();
              // 2. แจ้ง parent ให้ refresh datagrid
              if (props.onSaveSuccess) props.onSaveSuccess();
            } else {
              window.location = `./customer?customer_id=${props.CUSTOMER_CODE}`;
            }
          });
        } else {
          swal("Sorry", result.message, "error");
        }
      });
  };
  const allowedRoles = ["1", "2", "14"]; // ใส่ role_id ที่อนุญาต
  return (
    <>
      <Modal
        className="modal activity"
        show={props.show}
        onHide={props.onClose}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{subjectName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} id="modalForm">
            <Grid container className="Box" spacing={2}>
              <Grid item xs={12} sm={6}>
                <label>Activity date</label>
                <DateBox
                  value={activityDate ? new Date(activityDate) : now}
                  inputAttr={dateTimeLabel}
                  onValueChanged={onValueDateChanged}
                  type="datetime"
                  useMaskBehavior={true}
                  displayFormat="dd-MM-yyyy hh:mm a"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label>Type of Activity</label>
                <span className="red">*</span>
                <Select
                  placeholder="Select"
                  value={getStatus}
                  options={statusList}
                  onChange={handleStatusChange}
                  getOptionLabel={(x) => x.label}
                  getOptionValue={(x) => x.value}
                  required
                  isDisabled={isDisabled} // 👈 ปิดการเลือก
                />
              </Grid>

              {(props.ACTIVITY_ID > 0 || !props.CUSTOMER_CODE) && (
                <Grid item xs={12} sm={6}>
                  <label>Customer</label>
                  <span className="red">*</span>
                  <Select
                    placeholder="Select Customer"
                    value={customer}
                    options={customerList}
                    onChange={handleCustomerChange}
                    getOptionLabel={(x) => x.CUSTOMER_NAME}
                    getOptionValue={(x) => x.CRM_CUSCODE}
                    required
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12}>
                <label>Topic</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={activityName}
                  onChange={(e) => setActivityName(e.target.value)}
                  inputProps={{ maxLength: 250 }}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <label>Description</label>
                <span className="red">*</span>
                <Box
                  component="textarea"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  required
                  rows={6}
                  maxLength={1000} // ✅ ใส่ตรงนี้
                  style={{
                    width: "100%",
                    padding: "8px",
                    boxSizing: "border-box",
                    resize: "vertical", // ✅ ให้ขยายได้และรองรับหลายบรรทัด
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    whiteSpace: "pre-wrap", // ✅ แสดงบรรทัดใหม่จริง (กรณีมีค่า remark จาก database)
                    overflowWrap: "break-word", // ✅ ป้องกันคำยาวเกิน
                  }}
                />
                {/* ตัวอักษรที่พิมพ์และปุ่มเคลียร์ */}
                <div
                  style={{
                    display: "inline",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 4,
                    fontSize: 12,
                    color: "#555",
                    width: 400,
                  }}
                >
                  <span>{remark.length} / 1000 characters</span>
                  &nbsp;&nbsp;&nbsp;
                  {/* <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setRemark("");
                  setMentions([]);
                }}
              >
                Clear
              </Button> */}
                </div>
              </Grid>
              {allowedRoles.includes(getUserRole) ? (
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={reminderChecked}
                        onChange={(e) => setReminderChecked(e.target.checked)}
                      />
                    }
                    label="Reminder"
                  />
                </Grid>
              ) : (
                // โชว์กรณี role ไม่อยู่ใน allowedRoles
                <Grid item xs={12} sm={4}></Grid>
              )}
              {allowedRoles.includes(getUserRole) ? (
                <Grid item xs={12} sm={8}>
                  <DateBox
                    disabled={!reminderChecked}
                    value={reminderDate}
                    type="datetime"
                    onValueChanged={(e) => setReminderDate(e.value)}
                    placeholder="เลือกวันที่"
                    useMaskBehavior={true}
                    displayFormat="dd-MM-yyyy hh:mm a"
                  >
                    <Validator>
                      {/* ✅ rule จะทำงานเฉพาะตอนติ๊ก checkbox */}
                      <CustomRule
                        validationCallback={(e) => {
                          if (!reminderChecked) return true; // ไม่ติ๊ก = ไม่ต้อง validate
                          return !!e.value; // ถ้าติ๊ก = ต้องมีค่า
                        }}
                        message="กรุณาเลือกวันที่สำหรับ Reminder"
                      />
                    </Validator>
                  </DateBox>
                </Grid>
              ) : (
                // โชว์กรณี role ไม่อยู่ใน allowedRoles
                <Grid item xs={12} sm={8}></Grid>
              )}
              <Grid item xs={12} sm={6}>
                <label>Create by</label>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={createBy}
                  onChange={(e) => setCreateBy(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
            </Grid>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={props.onClose}>
            Close
          </button>
          <button className="btn btn-primary" form="modalForm" type="submit">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddActivityModal;
